import 'shared/common'
import '@carwow/carwow_theme/app/javascript/components/video'
import '@carwow/carwow_theme/app/javascript/components/sticky_header'
import { initGallery } from '@carwow/carwow_theme/app/javascript/components/gallery'
import { initVerticalCarousel } from '@carwow/carwow_theme/app/javascript/components/thumbnail_carousel_vertical'
import '@carwow/carwow_theme/app/javascript/components/button_back_to_top'
import '@carwow/carwow_theme/app/javascript/components/tooltip'
import '@carwow/carwow_theme/app/javascript/components/media_slider'

import initScrollToSection from 'shared/scroll_to_section'
import initOpenGalleryOnIndex from 'shared/gallery'

import 'lite-youtube-embed'

window.addEventListener('DOMContentLoaded', () => {
  initGallery(document)
  initVerticalCarousel()
  initScrollToSection()
  initOpenGalleryOnIndex()
})
